export default __webpack_public_path__ + "static/media/coaching.e56ced00.jpg";